'use client';

import { createContext, useContext, type PropsWithChildren } from 'react';
import { SequencingTrafficType, type SequencingConfigType } from '../../types/sequencing';
import { type SequencingHookReturnType } from '../hooks/types';
import { useSequencing } from '../hooks/useSequencing';
import type { MarketplaceSkuProductType } from '../../schema/offer-ids-types';

type SequencingContextProps = PropsWithChildren<{
  productType: MarketplaceSkuProductType;
  sequencingConfig: SequencingConfigType;
  slug: string;
  trafficType: SequencingTrafficType;
}>;

export const SequencingContext = createContext<SequencingHookReturnType | null>(null);

export const SequencingContextProvider = ({
  children,
  productType,
  sequencingConfig,
  slug,
  trafficType,
}: SequencingContextProps) => {
  const result = useSequencing({
    productType,
    sequencingConfig,
    slug,
    trafficType,
  });

  return <SequencingContext.Provider value={result}>{children}</SequencingContext.Provider>;
};

export function useSequencingContext() {
  const context = useContext(SequencingContext);
  if (!context) {
    throw new Error('useSequencingContext must be used within a SequencingContextProvider');
  }

  return context;
}
